export default __webpack_public_path__ + "static/media/Stage2_juuyou.b714b982.svg";